import { useDashboards } from 'dashboards/hooks/useDashboards';

import { Icon } from 'components/Icon/IconDeprecated';
import { Skeleton } from 'components/Skeleton/Skeleton';
import { SkeletonList } from 'components/Skeleton/SkeletonList';
import { Text } from 'components/Text/Text';

import { DashboardLink } from './DashboardLink';

export function MonitorDashboardLinks() {
  const { data: dashboards, isLoading, error } = useDashboards();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2">
        <SkeletonList
          min={5}
          max={5}
          component={<Skeleton className="h-6" />}
        />
      </div>
    );
  }

  if (error) {
    return (
      <Text intent="danger" align="center">
        <Icon name="warning" /> <br />
        <span>
          {error.message ??
            'Unable to load dashboards. Please try again later.'}
        </span>
      </Text>
    );
  }

  if (!dashboards?.total_elements || !dashboards.data.length) {
    return <p className="p-3">Dashboards will appear here.</p>;
  }

  return (
    <ul>
      {dashboards.data.map((dashboard) => (
        <DashboardLink dashboard={dashboard} key={dashboard.id} />
      ))}
    </ul>
  );
}
